export default "__VITE_ASSET__CIg4DALM__"